<app-loading [showLoading]="isAuthenticating()" />

<app-sidenav #sidenav>
    <app-header (toggleSidenav)="sidenav.toggle()" />
    <div class="breadcrumb-container">
        <app-route-breadcrumb />
    </div>
    <router-outlet />
</app-sidenav>
